import { useEffect, useRef } from 'react';
import { useAccessControl } from 'new/state/app/repository/useAppRepository';

function useHandleAccessLevelChanges(cb = () => {}, deps: any[] = []) {
  const isMounted = useRef(false);
  const { mode } = useAccessControl();

  useEffect(
    function detectAndHandleACLChanges() {
      if (isMounted.current) {
        cb?.();
      } else {
        isMounted.current = true;
      }
    },
    [mode, ...deps],
  );
}

export { useHandleAccessLevelChanges };
